// extracted by mini-css-extract-plugin
export default {"modal":"PreCopyWeblinkDialog__modal--IgGG2"};